import chalk from 'chalk';
import ora, { Ora } from 'ora';

/**
 * 로거 클래스 - 콘솔 출력을 관리합니다
 */
export class Logger {
  private static _spinner: Ora | null = null;

  /**
   * 성공 메시지 출력
   */
  public static success(message: string): void {
    console.log(chalk.green('✓'), message);
  }

  /**
   * 에러 메시지 출력
   */
  public static error(message: string): void {
    console.error(chalk.red('✗'), message);
  }

  /**
   * 경고 메시지 출력
   */
  public static warning(message: string): void {
    console.warn(chalk.yellow('⚠'), message);
  }

  /**
   * 정보 메시지 출력
   */
  public static info(message: string): void {
    console.log(chalk.blue('ℹ'), message);
  }

  /**
   * 디버그 메시지 출력
   */
  public static debug(message: string): void {
    if (process.env.DEBUG) {
      console.log(chalk.gray('🐛'), message);
    }
  }

  /**
   * 스피너 시작
   */
  public static startSpinner(message: string): void {
    this._spinner = ora(message).start();
  }

  /**
   * 스피너 성공으로 종료
   */
  public static succeedSpinner(message?: string): void {
    if (this._spinner) {
      this._spinner.succeed(message);
      this._spinner = null;
    }
  }

  /**
   * 스피너 실패로 종료
   */
  public static failSpinner(message?: string): void {
    if (this._spinner) {
      this._spinner.fail(message);
      this._spinner = null;
    }
  }

  /**
   * 스피너 중단
   */
  public static stopSpinner(): void {
    if (this._spinner) {
      this._spinner.stop();
      this._spinner = null;
    }
  }

  /**
   * 제목 출력
   */
  public static title(message: string): void {
    console.log();
    console.log(chalk.bold.cyan(message));
    console.log(chalk.cyan('='.repeat(message.length)));
  }

  /**
   * 부제목 출력
   */
  public static subtitle(message: string): void {
    console.log();
    console.log(chalk.bold(message));
    console.log(chalk.gray('-'.repeat(message.length)));
  }

  /**
   * 빈 줄 출력
   */
  public static newLine(): void {
    console.log();
  }
}
